import { render, staticRenderFns } from "./CheckoutDataError.vue?vue&type=template&id=53106540"
import script from "./CheckoutDataError.vue?vue&type=script&lang=js"
export * from "./CheckoutDataError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports